import { theme } from '@/utils/theme';

export const styles = {
  avatar: (size: number, src?: string | null) => ({
    height: size,
    width: size,
    fontSize: Math.min(size / 2, 36), // limit font size to max 36px (text-4xl)
    fontWeight: 700,
    textTransform: 'uppercase',
    backgroundColor: src ? 'white' : theme.palette['mint-2'].main,
    color: theme.palette['sage-10'].main,
    borderRadius: '0.75rem',
  }),
  circularProgress: {
    color: theme.palette['teal-1'].main,
    animationDuration: '2s',
    '& .MuiCircularProgress-circle': {
      animationDuration: '2s',
    },
  },
};
